<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "exhibition-order",
  data() {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
</style>